import { QUERY_STATE } from '@tmapy/utils';
import { htmlToPdf } from '../htmltopdf';
import { getFileName } from '../filename';
import { EXPORT_DONE, EXPORT_FAILED, EXPORT_BTN_CLICK, CHANGE_FIX_DIMENSION } from '../constants';
export const clickExport = (map, format) => async (dispatch, getState) => {
    const state = getState();
    const queryState = state.actionBar.queryState;
    const fileName = getFileName(getState().config.filename);
    // #44757 - to prevent unexpected multiple mouse click
    if (queryState === QUERY_STATE.WAITING)
        return;
    dispatch({ type: EXPORT_BTN_CLICK, format });
    const isSuccess = await htmlToPdf({
        map,
        format,
        fileName,
        domNode: document.getElementById('rpx-container'),
        afterHtmlSerialize: () => dispatch(changeFixDimension(false, format)),
    });
    if (isSuccess) {
        dispatch({ type: EXPORT_DONE });
    }
    else {
        dispatch({ type: EXPORT_FAILED });
    }
};
export const changeFixDimension = (isDimensionFixed, format) => ({
    type: CHANGE_FIX_DIMENSION,
    isDimensionFixed,
    format,
});
//# sourceMappingURL=actions.js.map